import React from 'react'

function Exchanges() {
  return (
    <div>Exchanges</div>
  )
}

export default Exchanges